<template>
  <el-form
    ref="gjwFormComp"
    class="comp-gjw-form"
    :model="form"
    :inline="configs.inline"
    :class="configs.class"
    :style="configs.style"
    :label-width="configs.labelWidth"
    :label-position="configs.labelPosition"
    :inline-message="configs.inlineMessage"
    :validate-on-rule-change="configs.validateOnRuleChange"
    :size="configs.size"
    :rules="rules"
  >
    <el-form-item
      v-for="(item, index) in items"
      :key="index"
      :label="item.label"
      :prop="item.prop"
      :style="item.formItemStyle"
      :class="item.formItemClass"
    >

      <!--input输入框-->
      <el-input
        v-if="item.type==='input'"
        v-model.trim="form[item.prop]"
        :style="item.style"
        :class="item.class"
        :type="item.inputType || 'text'"
        :clearable="item.clearable"
        :disabled="item.disabled"
        :rows="item.rows"
        :placeholder="item.placeholder || '请输入内容'"
        @change="(val)=>{valChange(val, item)}"
      />

      <!--数字输入框-->
      <el-input-number
        v-if="item.type==='inputNumber'"
        v-model="form[item.prop]"
        :style="item.style"
        :class="item.class"
        :disabled="item.disabled"
        :min="item.min"
        :max="item.max"
        :precision="item.precision"
        :controls="item.controls || false"
        :placeholder="item.placeholder || '请输入数字'"
        @change="(val)=>{valChange(val, item)}"
      />

      <!--一般下拉选择器-->
      <gjw-select
        v-if="item.type==='select'"
        :config="item"
        :init-value="form[item.prop]"
        @change="valChange"
      />

      <!--单选-->
      <el-radio-group
        v-if="item.type==='radio'"
        v-model="form[item.prop]"
        :disabled="item.disabled"
        :style="item.style"
        :class="item.class"
        :size="item.size"
        :text-color="item.textColor"
        :fill="item.fill"
        @change="(val)=>{valChange(val, item)}"
      >
        <div
          :is="item.isRadioButton ? 'el-radio-button' : 'el-radio'"
          v-for="(radio, i) in item.options"
          :key="i"
          :label="radio.value"
          :border="radio.border"
          :disabled="radio.disabled"
          :style="item.style"
          :class="item.class"
        >{{ radio.label }}</div>
      </el-radio-group>

      <!--多选 值独立 勾选/不勾选-->
      <el-checkbox
        v-if="item.type==='checkbox'"
        v-model="form[item.prop]"
        :style="item.style"
        :class="item.class"
        :true-label="item.trueLabel"
        :false-label="item.falseLabel"
        :disabled="item.disabled"
        :border="item.border"
        :size="item.size"
        @change="(val)=>{valChange(val, item)}"
      >{{ item.checkboxLabel }}</el-checkbox>

      <!--多选组 值为所有勾选的选项数组-->
      <gjw-checkbox-group
        v-if="item.type==='checkboxGroup'"
        :config="item"
        :init-value="form[item.prop]"
        @change="valChange"
      />

      <!--颜色选择器-->
      <div v-if="item.type==='colorPicker'" class="color-item" :style="item.style" :class="item.class">
        <el-color-picker
          v-model="form[item.prop]"
          :disabled="item.disabled"
          :size="item.size"
          :show-alpha="item.showAlpha"
          :popper-class="item.popperClass"
          :predefine="item.predefine"
          @change="(val)=>{valChange(val, item)}"
        />
        <span v-if="item.showValue" class="color-value">{{ form[item.prop] }}</span>
      </div>
      <!--具名插槽-->
      <slot v-if="item.slotName" :name="item.slotName" />
    </el-form-item>
  </el-form>
</template>

<script>
import GjwSelect from '../../gjwSelect/src/GjwSelect'
import GjwCheckboxGroup from '../../gjwCheckboxGroup/src/GjwCheckboxGroup'
export default {
  name: 'GjwForm',
  components: { GjwSelect, GjwCheckboxGroup },
  props: {
    // 表单项的配置
    items: {
      type: Array,
      default() {
        return []
      }
    },
    // 表单的校验规则
    rules: {
      type: Object,
      default() {
        return {}
      }
    },
    config: {
      type: Object,
      default() {
        return {}
      }
    },
    // 表单初始值
    initData: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    return {
      form: {},
    }
  },
  computed: {
    configs() {
      const defaultConfig = {
        class: '',
        style: '',
        inline: false,
        labelWidth: '80px',
        labelPosition: 'right',
        inlineMessage: false,
        validateOnRuleChange: true,
        size: '',
      }
      return { ...defaultConfig, ...this.config }
    }
  },
  watch: {
    initData: {
      handler(newVal) {
        this.form = { ...newVal }
      },
      immediate: true,
    }
  },
  methods: {
    checkForm() {
      let flag = false
      this.$refs.gjwFormComp.validate((valid) => {
        flag = valid
      })
      return flag
    },
    reset() {
      this.$refs.gjwFormComp.resetFields()
      this.form = {}
    },
    valChange(val, item) {
      this.form = { ...this.form, [item.prop]: val }
      if (this.rules[item.prop]) {
        this.$nextTick(() => {
          this.$refs.gjwFormComp && this.$refs.gjwFormComp.validateField(item.prop)
        })
      }
      this.$emit('form-change', { [item.prop]: val }, this.form)
    },
  }
}
</script>

<style lang="less" scoped>
  .comp-gjw-form{
    .color-item{
      display: flex;
      align-items: center;
    }
    .color-value{
      margin-left: 14px;
    }
  }
</style>
